import React, { useState, useRef, useEffect } from "react";
import { useUserState } from "../../../providers/UserProvider";
import { Input } from "../../../components/Input";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ButtonComponent from "../../../components/ButtonComponent";
import * as HTTPServices from "../../../api/HTTPServices";
import { COLORS } from "../../../lib/colors";
import SampleImage from "../../../assets/images/sampleUser/236-236.png";
import classes from "./index.module.scss";
import { useTranslation } from "react-i18next";
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import _ from "lodash";
import * as Toast from "../../../lib/toast";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import CustomSelect from "../../../components/Select";
import { Link } from "react-router-dom";

function Index() {
  const { t } = useTranslation();

  const user = useUserState();
  const [profileImage, setprofileImage] = useState(SampleImage);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [nationalCode, setNationalCode] = useState("");
  const [bankAccountNumber, setBankAccountNumber] = useState("");
  const [date, setDate] = useState(moment("28-11-1987", "DD-MM-YYYY"));
  const [job, setJob] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [optionsCity, setOptionsCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [myPatientOnly, setMyPatientOnly] = useState(false);
  const [videoConsultation, setVideoConsultation] = useState(false);
  const [voiceConsultation, setVoiceConsultation] = useState(false);
  const [textConsultation, setTextConsultation] = useState(false);
  const [passwordEdit, setPasswordEdit] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  // const [error, setError] = useState(false);
  const [errorMessage, seterrorMessage] = useState({});
  const [loading, setLoading] = useState(false);

  const inputFile = useRef(null);
  let userType = user?.user_login?.approve;

  useEffect(() => {
    // setValue(moment("25-12-1995", "DD-MM-YYYY"));
    let RequestService;
    if (userType === "doctor") {
      RequestService = HTTPServices.getMethod("doctor_profile", "", "true");
      RequestService.then(function (response) {
        if (response) {
          console.log(`response`, response);
        } else {
        }
      }).catch(function (error) {});
    } else {
      RequestService = HTTPServices.getMethod("user_profile", "", "true");
      RequestService.then(function (response) {
        if (response) {
          console.log(`response`, response);
          let {
            account_sheba,
            address,
            // bio,
            birthday,
            city,
            email,
            family,
            job,
            // mobile,
            name,
            nid,
            picture,
          } = response.profile;
          let statesItem = {};
          let statesList = [];
          let states = response.states;

          _.map(states, (state) => {
            statesList.push({ value: state.id, label: state.state });
            if (response.profile.state === state.id) {
              statesItem = { value: state.id, label: state.state };
              getcity(state.id, response.profile.city);
            }
          });

          setprofileImage(picture);
          setFirstName(name);
          setLastName(family);
          setNationalCode(nid);
          setBankAccountNumber(account_sheba);
          setDate(moment(birthday));
          setJob(job);
          setStates(statesList);
          setSelectedState(statesItem);
          setSelectedCity(city);
          setAddress(address);
          setEmail(email);
        } else {
        }
      }).catch(function (error) {});
    }
  }, [userType]);

  const getcity = (select_value) => {
    setOptionsCity([]);
    // setSelectedCity("");

    const params = new URLSearchParams();
    params.append("state", select_value);

    const RequestService = HTTPServices.postMethod("city", params, "true");
    RequestService.then(function (response) {
      if (response) {
        // let Item = [];
        let List = [];
        _.map(response, (city) => {
          List.push({ value: city.id, label: city.city });
        });
        setOptionsCity(List);
        // setSelectedCity(Item);
      }
    });
  };

  const handleChange = (e) => {
    switch (e.target.name) {
      case "firstName":
        setFirstName(e.target.value);
        break;
      case "lastName":
        setLastName(e.target.value);
        break;
      case "nationalCode":
        setNationalCode(e.target.value);
        break;
      case "bankAccountNumber":
        setBankAccountNumber(e.target.value);
        break;
      case "job":
        setJob(e.target.value);
        break;
      case "address":
        setAddress(e.target.value);
        break;
      case "email":
        setEmail(e.target.value);
        break;
      case "myPatientOnly":
        setMyPatientOnly(e.target.checked);
        break;
      case "videoConsultation":
        setVideoConsultation(e.target.checked);
        break;
      case "voiceConsultation":
        setVoiceConsultation(e.target.checked);
        break;
      case "textConsultation":
        setTextConsultation(e.target.checked);
        break;
      case "passwordEdit":
        setPasswordEdit(e.target.checked);
        break;
      case "oldPassword":
        setOldPassword(e.target.value);
        break;
      case "newPassword":
        setNewPassword(e.target.value);
        break;
      case "confirmPassword":
        setConfirmPassword(e.target.value);
        break;
      default:
        break;
    }
  };

  const handleSubmit = () => {
    let formData = new FormData();
    if (userType === "doctor") {
      formData.append("name", firstName);
      formData.append("family", lastName);
      formData.append("nid", nationalCode);
      formData.append("job", job);
      formData.append("account_sheba", bankAccountNumber);
      if (passwordEdit) {
        formData.append("old_password", null);
        formData.append("new_password", null);
      }
      formData.append("address", address);
      formData.append("email", email);
      formData.append("city", selectedCity ? selectedCity : 0);
      formData.append("state", selectedState ? selectedState.value : 0);
      formData.append("my_patient_only", myPatientOnly);
      formData.append("videoConsultation", videoConsultation);
      formData.append("voiceConsultation", voiceConsultation);
      formData.append("textConsultation", textConsultation);
      const RequestService = HTTPServices.postMethod(
        "user_profile",
        formData,
        "true"
      );
      RequestService.then(function (response) {
        if (response) {
          console.log(`response`, response);
        } else {
        }
      }).catch(function (error) {});
    } else {
      let isError = false;
      if (firstName.length < 3) {
        isError = true;
        // setError(true);
        seterrorMessage({ firstName: "enter correct value" });
        return;
      }
      if (lastName.length < 3) {
        isError = true;
        // setError(true);
        seterrorMessage({ lastName: "enter correct value" });
        return;
      }
      if (nationalCode.length !== 10 || isNaN(nationalCode)) {
        isError = true;
        // setError(true);
        seterrorMessage({ nationalCode: "enter correct value" });
        return;
      }
      if (bankAccountNumber.length !== 24 || isNaN(nationalCode)) {
        isError = true;
        // setError(true);
        seterrorMessage({ bankAccountNumber: "enter correct value" });
        return;
      }
      if (!selectedState) {
        isError = true;
        // setError(true);
        seterrorMessage({ selectedState: "enter correct value" });
        return;
      }
      if (!selectedCity) {
        isError = true;
        // setError(true);
        seterrorMessage({ selectedCity: "enter correct value" });
        return;
      }
      if (email && !validateEmail(email)) {
        seterrorMessage({ email: "enter correct value" });
        return;
      }
      if (!isError) {
        //add else if for validating other fields (if any)
        // setError(false);
        seterrorMessage({});
      }

      setLoading(true);
      formData.append("name", firstName);
      formData.append("family", lastName);
      formData.append("nid", nationalCode);
      formData.append("job", job);
      formData.append("account_sheba", bankAccountNumber);
      formData.append("birthday", date);
      formData.append("address", address);
      formData.append("email", email);
      formData.append("city", selectedCity ? selectedCity : 0);
      formData.append("state", selectedState ? selectedState.value : 0);
      if (passwordEdit) {
        formData.append("old_password", oldPassword);
        formData.append("new_password", newPassword);
      }
      const RequestService = HTTPServices.postMethod(
        "user_profile",
        formData,
        "true"
      );
      RequestService.then(function (response) {
        if (response) {
          setLoading(false);
          Toast.SuccessData("profile data succsefully updated");
          console.log(`response`, response);
        } else {
        }
      }).catch(function (error) {
        Toast.ErrorData("some thing went wrong");

        setLoading(false);
      });
    }
  };

  const onAvatarClick = () => {
    // `current` points to the mounted file input element
    inputFile.current.click();
  };

  const handleSetImage = () => {
    let formData = new FormData();
    if (inputFile.current.files[0].size > 1000000) {
      return Toast.ErrorData("file must be under 1 megabites");
    }
    formData.append("photo", inputFile.current.files[0]);

    const RequestService = HTTPServices.postMethod(
      "user_avatar",
      formData,
      "true"
    );

    RequestService.then(function (response) {
      if (response) {
        Toast.SuccessData("profile has been updated");
        setprofileImage(response);
      } else {
      }
    }).catch(function (error) {
      Toast.ErrorData(error.message);
    });
  };

  const handleChangeDate = (newValue) => {
    setDate(newValue);
  };

  const handleChangeState = (selectedState) => {
    setSelectedState(selectedState.target);
    getcity(selectedState.target.value);
  };

  const handleChangeCity = (selectedCity) => {
    setSelectedCity(selectedCity.target.value);
  };

  function validateEmail(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const renderForm = () => {
    let userType = (user && user.user_login.approve) || "";
    switch (userType) {
      case "user":
        return (
          <div className={classes.mainForm}>
            <div className={classes.avatarContainer} onClick={onAvatarClick}>
              <Avatar
                alt={t("pages.protectedPages.profile.User.image")}
                src={profileImage}
                sx={{ width: 168, height: 168 }}
                className={classes.avatar}
              />
              <div className={classes.overlay}>click to upload photo</div>

              <input
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: "none" }}
                accept="image/png, image/jpg, image/jpeg"
                onChange={handleSetImage}
              />
            </div>
            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="firstName"
                  label={t("pages.protectedPages.profile.User.firstName")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && errorMessage.lastName}
                  name="lastName"
                  label={t("pages.protectedPages.profile.User.lastName")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={lastName}
                />
              </div>
            </div>
            {/* errors will return when field validation fails  */}
            {/* {errors.firstName && (
              <span>{t("pages.protectedPages.profile.required")}</span>
            )} */}

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.nationalCode}
                  helperText={
                    errorMessage.nationalCode && errorMessage.nationalCode
                  }
                  name="nationalCode"
                  label={t("pages.protectedPages.profile.User.nationalCode")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={nationalCode}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.bankAccountNumber}
                  helperText={
                    errorMessage.bankAccountNumber &&
                    errorMessage.bankAccountNumber
                  }
                  name="bankAccountNumber"
                  label={t(
                    "pages.protectedPages.profile.User.bankAccountNumber"
                  )}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={bankAccountNumber}
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <MobileDatePicker
                  label={t("pages.protectedPages.profile.User.birthday")}
                  views={["year", "month", "day"]}
                  value={date}
                  onChange={handleChangeDate}
                  renderInput={(params) => <Input {...params} fullWidth />}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  name="job"
                  label={t("pages.protectedPages.profile.User.job")}
                  onChange={handleChange}
                  fullWidth
                  value={job}
                />
              </div>
            </div>
            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <CustomSelect
                  error={!!errorMessage.selectedState}
                  label={t("pages.protectedPages.profile.User.state")}
                  multiple={false}
                  value={selectedState.value}
                  handleChange={handleChangeState}
                  options={states}
                  required={true}
                  fullWidth
                  errorMessage={
                    errorMessage.selectedState && errorMessage.selectedState
                  }
                />
              </div>
              <div className={classes.inputContainer}>
                <CustomSelect
                  error={!!errorMessage.selectedCity}
                  label={t("pages.protectedPages.profile.User.city")}
                  multiple={false}
                  value={selectedCity}
                  handleChange={handleChangeCity}
                  options={optionsCity}
                  required={true}
                  fullWidth
                  errorMessage={
                    errorMessage.selectedCity && errorMessage.selectedCity
                  }
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  name="address"
                  label={t("pages.protectedPages.profile.User.address")}
                  value={address}
                  onChange={handleChange}
                  fullWidth
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.email}
                  helperText={errorMessage.email && errorMessage.email}
                  name="email"
                  label="email"
                  onChange={handleChange}
                  value={email}
                  fullWidth
                />
              </div>
            </div>

            <div>
              <div style={{ textAlign: "center" }}>
                <FormControlLabel
                  className="CheckboxSbm"
                  control={
                    <Checkbox
                      name="passwordEdit"
                      checked={passwordEdit}
                      onChange={handleChange}
                      value="checkedA"
                      color="primary"
                    />
                  }
                  label={t("pages.protectedPages.profile.changePassword")}
                />
              </div>
              {passwordEdit && (
                <div className={classes.passwordContainer}>
                  <div className={classes.inputContainer}>
                    <Input
                      type="password"
                      name="oldPassword"
                      label={t("pages.protectedPages.profile.User.oldPassword")}
                      value={oldPassword}
                      onChange={handleChange}
                      required
                      fullWidth
                    />
                  </div>

                  <div className={classes.inputContainer}>
                    <Input
                      type="password"
                      name="newPassword"
                      label={t("pages.protectedPages.profile.User.newPassword")}
                      value={newPassword}
                      onChange={handleChange}
                      required
                      fullWidth
                    />
                  </div>
                  <div className={classes.inputContainer}>
                    <Input
                      type="password"
                      name="confirmPassword"
                      label={t(
                        "pages.protectedPages.profile.User.confirmPassword"
                      )}
                      value={confirmPassword}
                      onChange={handleChange}
                      required
                      fullWidth
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        );
      case "doctor":
        return (
          <div className={classes.mainForm}>
            <div className={classes.avatarContainer} onClick={onAvatarClick}>
              <Avatar
                alt={t("pages.protectedPages.profile.doctor.image")}
                src={profileImage}
                sx={{ width: 168, height: 168 }}
                className={classes.avatar}
              />
              <div className={classes.overlay}>click to upload photo</div>

              <input
                type="file"
                id="file"
                ref={inputFile}
                style={{ display: "none" }}
                accept="image/png, image/jpg, image/jpeg"
                onChange={handleSetImage}
              />
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="firstName"
                  label={t("pages.protectedPages.profile.doctor.firstName")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && errorMessage.lastName}
                  name="lastName"
                  label={t("pages.protectedPages.profile.doctor.lastName")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={lastName}
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="titleOnBoard"
                  label={t("pages.protectedPages.profile.doctor.titleOnBoard")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && errorMessage.lastName}
                  name="nationalCode"
                  label={t("pages.protectedPages.profile.doctor.nationalCode")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={lastName}
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="medicalSystemNumberOrUnionSystem"
                  label={t(
                    "pages.protectedPages.profile.doctor.medicalSystemNumberOrUnionSystem"
                  )}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && errorMessage.lastName}
                  name="shebaAccountNumber"
                  label={t(
                    "pages.protectedPages.profile.doctor.shebaAccountNumber"
                  )}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={lastName}
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="biography"
                  label={t("pages.protectedPages.profile.doctor.biography")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.lastName}
                  helperText={errorMessage.lastName && errorMessage.lastName}
                  name="state"
                  label={t("pages.protectedPages.profile.doctor.state")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={lastName}
                />
              </div>
            </div>

            <div className={classes.twoColContainer}>
              <div className={classes.inputContainer}>
                <Input
                  error={!!errorMessage.firstName}
                  helperText={errorMessage.firstName && errorMessage.firstName}
                  name="address"
                  label={t("pages.protectedPages.profile.doctor.address")}
                  onChange={handleChange}
                  required
                  fullWidth
                  value={firstName}
                />
              </div>
              <div className={classes.inputContainer}></div>
            </div>

            <hr />
            <label>
              {t("pages.protectedPages.profile.doctor.visitingConditions")}
            </label>

            <div style={{ marginRight: 30 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="myPatientOnly"
                    checked={myPatientOnly}
                    onChange={handleChange}
                    value="checkedA"
                    color="primary"
                  />
                }
                label={t("pages.protectedPages.profile.doctor.onlyMyPatients")}
              />
            </div>
            <div style={{ margin: "10px", padding: "3px" }}>
              <Grid container spacing={4}>
                <Grid item xs={4} sm={4}>
                  <Grid>
                    <label>
                      {t("pages.protectedPages.profile.doctor.videovisit")}
                    </label>
                  </Grid>
                  <Grid>
                    <Checkbox
                      checked={videoConsultation}
                      onChange={handleChange}
                      name="videoConsultation"
                      value={videoConsultation}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Grid>
                    <label>
                      {t("pages.protectedPages.profile.doctor.VoiceVisit")}
                    </label>
                  </Grid>
                  <Grid>
                    <Checkbox
                      checked={voiceConsultation}
                      onChange={handleChange}
                      name="voiceConsultation"
                      value={voiceConsultation}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={4} sm={4}>
                  <Grid>
                    <label>
                      {t("pages.protectedPages.profile.doctor.textVisit")}
                    </label>
                  </Grid>
                  <Grid>
                    <Checkbox
                      checked={textConsultation}
                      onChange={handleChange}
                      name="textConsultation"
                      value={textConsultation}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </div>
            <hr />
            <div>
              <div>
                <FormControlLabel
                  className="CheckboxSbm"
                  control={
                    <Checkbox
                      name="passwordEdit"
                      checked={passwordEdit}
                      onChange={handleChange}
                      value="checkedA"
                      color="primary"
                    />
                  }
                  label={t("pages.protectedPages.profile.doctor.changePass")}
                />
              </div>
              {passwordEdit && (
                <div>
                  <div>
                    <label>
                      {t("pages.protectedPages.profile.doctor.oldPass")}
                    </label>
                    <Input type="password" />
                  </div>

                  <div>
                    <label>
                      {t("pages.protectedPages.profile.doctor.newPass")}
                    </label>
                    <Input type="password" />
                  </div>
                  <div>
                    <label>
                      {t("pages.protectedPages.profile.doctor.confirmPass")}
                    </label>
                    <Input type="password" />
                  </div>
                </div>
              )}
            </div>
          </div>
        );

      default:
        break;
    }
  };

  return (
    <div className={classes.mainContainer}>
      <h3 className={classes.title}>
        {t("pages.protectedPages.profile.title")}
      </h3>
      {/* <h4 style={{ padding: 10, textAlign: "center" }}>
        {t("pages.protectedPages.profile.desc")}
      </h4> */}
      <div className={classes.formContainer}>
        {renderForm()}
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            marginBottom: 40,
          }}
        >
          <Link to={"/medical-history"}>
            <ButtonComponent
              className={null}
              backgroundColor={COLORS.yellow}
              onClick={null}
              loading={loading}
              disabled={loading}
              width={200}
            >
              Medical document
            </ButtonComponent>
          </Link>
          <ButtonComponent
            className={null}
            backgroundColor={COLORS.purple}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
            width={200}
          >
            {t("pages.protectedPages.profile.Button")}
          </ButtonComponent>
        </div>
      </div>
    </div>
  );
}

export default Index;
